import { render, staticRenderFns } from "./PlanAndEmergencyDetail.vue?vue&type=template&id=aedd358e&scoped=true"
import script from "./PlanAndEmergencyDetail.vue?vue&type=script&lang=js"
export * from "./PlanAndEmergencyDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanAndEmergencyDetail.vue?vue&type=style&index=0&id=aedd358e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedd358e",
  null
  
)

export default component.exports